import { useEffect } from "react";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";
import { supabase } from "@/integrations/supabase/client";

const EXEMPT_PATHS = ["/complete-profile", "/login", "/register", "/terms", "/invite", "/reset-password", "/update-password"];

export function ProfileCompletionGuard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading || !user) return;
    if (EXEMPT_PATHS.includes(location.pathname)) return;

    let cancelled = false;
    supabase.from("profiles")
      .select("phone_number,address,lat,lng,full_name")
      .eq("id", user.id)
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled || !data) return;
        const incomplete =
          !data.full_name?.trim() ||
          !data.phone_number?.trim() ||
          !data.address?.trim() ||
          data.lat == null ||
          data.lng == null;
        if (incomplete) navigate({ to: "/complete-profile" });
      });
    return () => { cancelled = true; };
  }, [user, loading, location.pathname, navigate]);

  return null;
}
